import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsCancelNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M2.116 3l.883-.885 5 5 5.001-5 .884.884-5 5 5 5-.884.885-5-5-5 5L2.116 13l5-5z"
        fill=""
      />
    </svg>
  )
);
SvgActionsCancelNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsCancelNormalXsmall;
